import { ActionType, ChangeMediaOperationType, ChangeMediaType, ContentType, EventType, SenderType } from '@/const/mission';
import { IEvents } from '@/interface';

export const handleExportEvents = (
  compValue: IEvents[],
  batchCheckList: string[],
  botList: {
    name: string;
    id: string;
    url: string;
  }[],
  propsList: {
    name: string;
    id: string;
  }[],
  filter?: boolean,
) => {
  // 获取选中的剧情内容
  const selectedEvents = filter && batchCheckList?.length > 0 ? compValue
    ?.filter(item => batchCheckList?.includes(item.keyIndex as string)) : compValue;
  // 格式化剧情内容

  const getDubExtendText = (event: IEvents) => {
    const dubText = event?.message?.text?.dubUrl?.url ? event?.message?.text?.dubUrl?.name : '';
    const extendsText = dubText ? `##${dubText?.trim()}` : '';
    return extendsText;
  };
  const formattedContent = selectedEvents?.map((event) => {
    // 根据不同事件类型格式化内容
    if (event?.type === EventType.EVENT_TYPE_MESSAGE) {
      if (event?.message?.type === ContentType.CONTENT_TYPE_TEXT) {
        if (event?.message?.sender?.type === SenderType.SYSTEM) { // 旁白
          const extendsText = getDubExtendText(event);
          return `【旁白】${event?.message?.text?.text || ''}${extendsText}`;
        }
        if (event?.message?.sender?.type === SenderType.BOT) { // 角色
          const extendsText = getDubExtendText(event);
          const findName = botList?.find(item => item?.id === event?.message?.sender?.senderId)?.name || '';
          return `【${findName}】${event?.message?.text?.text || ''}${extendsText}`;
        }
        if (event?.message?.sender?.type === SenderType.USER) {
          const extendsText = getDubExtendText(event);
          const findName = botList?.find(item => item?.id === event?.message?.sender?.senderId)?.name || '';
          return `【${findName}】${event?.message?.text?.text || ''}${extendsText}`; // 玩家
        }
      }
    }

    if (event?.type === EventType.EVENT_TYPE_ACTION) {
      if (event?.action?.type === ActionType.ACTION_TYPE_CHANGEMEDIA) {
        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_IMAGE) {
          if (event?.action?.changeMedia?.operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE) {
            return '【移除背景图】';
          }
          return `【背景图】${event?.action?.changeMedia?.backgroundImage?.url?.name || ''}`;
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_FOREGROUND_IMAGE) {
          if (event?.action?.changeMedia?.operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE) {
            return '【移除立绘】';
          }
          return `【立绘】${event?.action?.changeMedia?.foregroundImage?.url?.name || ''}`;
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER) {
          if (event?.action?.changeMedia?.operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE) {
            return '【移除多人立绘】';
          }
          return '【多人立绘】';
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE) {
          if (event?.action?.changeMedia?.operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE) {
            return '【移除Spine立绘】';
          }
          return `【Spine 立绘】${event?.action?.changeMedia?.spine?.directoryName || ''}`;
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BGM_AUDIO) {
          if (event?.action?.changeMedia?.operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE) {
            return '【暂停背景音乐】';
          }
          if (event?.action?.changeMedia?.bgmAudio?.loopPlay === true) {
            return `【背景音乐】${event?.action?.changeMedia?.bgmAudio?.url?.name || ''}`;
          }
          return `【音效】${event?.action?.changeMedia?.bgmAudio?.url?.name || ''}`;
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO) {
          return `【视频】${event?.action?.changeMedia?.fullVideo?.url?.name || ''}`;
        }

        if (event?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO) {
          return `【背景视频】${event?.action?.changeMedia?.backgroundVideo?.url?.name || ''}`;
        }
      }
      if (event?.action?.type === ActionType.ACTION_TYPE_SHOWCARD) {
        const findName = propsList?.find(item => item?.id === event?.action?.showAsset?.itemCard?.id)?.name || '';
        return `【道具卡】${event?.action?.showAsset?.itemCard?.name || findName || ''}`;
      }
    }
  }); // 使用两个换行符分隔不同的剧情内容
  return formattedContent;
};
